import React from 'react';
import { Routes } from 'react-scale/components/GrowthCenter/urls';
import { Button, Typography, BaseIcon } from '@scale/scaleui';
import { Link } from 'react-router-dom';

type SmsSetupHeaderProps = {
  text: string;
};

const SmsSetupHeader: React.FC<SmsSetupHeaderProps> = ({ text }) => {
  return (
    <div className="sticky top-0 flex w-full flex-col bg-neutral-0 border-b border-b-neutral-200 justify-between p-1">
      <Link to={Routes.Sms} className="flex gap-3 items-center">
        <Button className="w-fit bg-transparent shadow-none" variant="neutral">
          <BaseIcon contrastText edge="start" icon={['fas', 'arrow-left']} variant="neutral" />
          Exit
        </Button>
      </Link>
      <div className="flex flex-row justify-between">
        <div className="flex flex-col">
          <Typography.Paragraph1 className="text-neutral-900 ml-2 font-medium">
            {text}
          </Typography.Paragraph1>
        </div>
      </div>
    </div>
  );
};

export default SmsSetupHeader;
